module.exports = __webpack_public_path__ + "static/media/gk-testimonials-2.eeac705a.png";